export const DATAHUB_TITLES = {
  exportSelection: 'GX Go | Export selection',
  pastExports: 'GX Go | Past exports'
} as const;
